module.exports = __webpack_public_path__ + "img/trinity_icon.88402bf5.gif";